import { c as _c } from "react/compiler-runtime";
import { FaCheck } from "react-icons/fa";
import { cx } from "@/lib/tailwind-utils";
interface SelectionCircleProps {
  isSelected: boolean;
  /** When > 1, render the count instead of the check so duplicates read clearly. */
  count?: number;
  className?: string;
}
export const SelectionCircle = t0 => {
  const $ = _c(12);
  const {
    isSelected,
    count: t1,
    className
  } = t0;
  const count = t1 === undefined ? 0 : t1;
  const showCount = count > 1;
  const t2 = showCount ? "w-6 h-6 md:w-6 md:h-6 px-1" : "w-5 h-5 md:w-5 md:h-5";
  const t3 = isSelected ? "border-primary bg-primary" : "border-foreground-muted";
  const t4 = !showCount && "scale-110 md:scale-100";
  let t5;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = cx("rounded-full border-2 flex items-center justify-center transition-all duration-200 flex-shrink-0", t2, t3, t4, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== count || $[6] !== isSelected || $[7] !== showCount) {
    t6 = showCount ? <span className="text-white text-[10px] md:text-[11px] font-semibold leading-none">×{count}</span> : <FaCheck className={cx("text-white size-2 md:size-2.5", isSelected ? "visible" : "invisible")} />;
    $[5] = count;
    $[6] = isSelected;
    $[7] = showCount;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};